import { Footer } from "@deere/fuel-react";
function tpFooter() {
  return (
    <Footer
      id="footer"
      style={{
        zIndex: "100",
        position: "fixed",
        width: "100%",
        bottom: "0",
        height: "60px",
        boxShadow: "rgb(240 240 240) 0px 2px",
      }}
    />
  );
}

export default tpFooter;
